import './StepIndicator.css';

interface StepProps {
  number: number;
  label: string;
  active: boolean;
  done: boolean;
}

function Step({ number, label, active, done }: StepProps) {
  return (
    <div className="step-item">
      <div
        className={`step-circle ${
          done ? 'step-circle--done' : active ? 'step-circle--active' : ''
        }`}
      >
        {done ? <i className="ri-check-line" /> : number}
      </div>
      <span
        className={`step-label ${
          active ? 'step-label--active' : done ? 'step-label--done' : ''
        }`}
      >
        {label}
      </span>
    </div>
  );
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Array<{ number: number; label: string }>;
}

export default function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  return (
    <div className="step-indicator">
      {steps.map((s, i) => (
        <>
          <Step
            key={s.number}
            number={s.number}
            label={s.label}
            active={currentStep === s.number}
            done={currentStep > s.number}
          />
          {i < steps.length - 1 && (
            <div
              key={`line-${s.number}`}
              className={`step-connector ${currentStep > s.number ? 'step-connector--done' : ''}`}
            />
          )}
        </>
      ))}
    </div>
  );
}